import { connect } from 'react-redux';
import ProjectStatus from './ProjectStatus';

import {
    setSoldStatus,
    setArchiveStatus,
    setJobStatus,
} from '../../common/projectstatus/actions';

import { setProjectStatusIsVisible } from './actions';


const mapStateToProps = state => ({
    archiveStatus: state.projectstatus.archiveStatus,
    soldStatus: state.projectstatus.soldStatus,
    jobStatus: state.projectstatus.jobStatus,
    isVisible: state.projectStatusUI.isVisible,
});

const combinedActions = {
    setSoldStatus,
    setArchiveStatus,
    setJobStatus,
    setProjectStatusIsVisible,
};

export default connect(mapStateToProps, combinedActions)(ProjectStatus);



// WEBPACK FOOTER //
// ./src/containers/Inputs/ProjectStatus/index.js